/******************************************************************************
 *** MbrasLeaveHistory ** 휴직 상세내용
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import RadioBox from "@/js/common/ui/input/RadioBox";
import Util from "@/js/common/Util";
import React from "react";

import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";
import MemberFileView from "../../mbras/FileBox/MemberFileView";

interface Props {
    mbrasId        : string;
    mbrasAtrzDocId : string;
    showAtrzLine?  : boolean;
}

const MbrasLeaveHistory = ({ mbrasId, mbrasAtrzDocId, showAtrzLine = true }: Props) => {
    const [openLine, setOpenLine] = React.useState(false);

    const [mbrasNm        , setMbrasNm        ] = React.useState(""); // 조합원명
    const [telno          , setTelno          ] = React.useState(""); // 휴대전화번호
    const [brdtDate       , setBrdtDate       ] = React.useState(""); // 생년월일
    const [gndrCd         , setGndrCd         ] = React.useState(""); // 성별코드
    const [mbrasAtrzSeCd  , setMbrasAtrzSeCd  ] = React.useState(""); // 조합원 결재 구분코드
    const [aplyYmd        , setAplyYmd        ] = React.useState(""); // 신청일자
    const [leaveBgngYmd   , setLeaveBgngYmd   ] = React.useState(""); // 휴직 시작일자
    const [leaveEndYmd    , setLeaveEndYmd    ] = React.useState(""); // 휴직 종료일자
    const [mbrasJoinSttsCd, setMbrasJoinSttsCd] = React.useState(""); // 현재 조합원 상태
    const [chgJoinSttsCd  , setChgJoinSttsCd  ] = React.useState(""); // 변경 조합원 상태
    const [leaveTypeCd    , setLeaveTypeCd    ] = React.useState(""); // 휴직분류
    const [leaveEtcRsnCn  , setLeaveEtcRsnCn  ] = React.useState(""); // 휴직 기타사유
    const [wthdAgreCd     , setWthdAgreCd     ] = React.useState(""); // 현재 원천징수 상태
    const [chgWthdAgreCd  , setChgWthdAgreCd  ] = React.useState(""); // 변경 원천징수 상태
    const [wthdAtchFileId , setWthdAtchFileId ] = React.useState(""); // 원천징수 첨부파일 ID
    const [wthdFileNm     , setWthdFileNm     ] = React.useState(""); // 원천징수 첨부파일명
    const [etcAtchFileId  , setEtcAtchFileId  ] = React.useState(""); // 기타 첨부파일 ID
    const [etcFileNm      , setEtcFileNm      ] = React.useState(""); // 기타 첨부파일명
    const [listLine       , setListLine       ] = React.useState<any[]>([]); // 결재라인

    // 변경 신청 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId,
            },
            onSuccessFn: (res: any) => {
                const mbrasDoc = res.result.mbrasDoc;
                const listItem = res.result.listItem;
                const listFile = res.result.listFile;
                const atrzLine = res.result.listLine;
                const joinSttsItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "07"); // 조합원 상태
                const wthdStatusItem = listItem.find((item: any) => item.mbrasInfoChgSeCd === "08"); // 원천징수 상태
                const leaveDateItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "09"); // 휴직기간
                const leaveTypeItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "10"); // 휴직분류

                const wthdFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "02"); // 원천징수 첨부파일
                const etcFileInfo  = listFile.find((item: any) => item.mbrasFileSeCd === "03"); // 기타 첨부파일

                setMbrasNm(mbrasDoc.mbrasNm);
                setTelno(mbrasDoc.telno);
                setBrdtDate(mbrasDoc.brdtDate);
                setGndrCd(mbrasDoc.gndrCd);
                setMbrasAtrzSeCd(mbrasDoc.mbrasAtrzSeCd);
                setAplyYmd(mbrasDoc.applyDt);

                setLeaveBgngYmd(leaveDateItem.chgBefCn);
                setLeaveEndYmd(leaveDateItem.chgAfterCn);
                setMbrasJoinSttsCd(joinSttsItem.chgBefCn);
                setChgJoinSttsCd(joinSttsItem.chgAfterCn);
                setLeaveTypeCd(leaveTypeItem.chgBefCn);
                setLeaveEtcRsnCn(leaveTypeItem.chgAfterCn);
                setWthdAgreCd(wthdStatusItem.chgBefCn);
                setChgWthdAgreCd(wthdStatusItem.chgAfterCn);

                if (Util.isNotEmpty(wthdFileInfo)) {
                    setWthdAtchFileId(wthdFileInfo.mbrasAtchFileId);
                    setWthdFileNm(wthdFileInfo.fileNm);
                }

                if (Util.isNotEmpty(etcFileInfo)) {
                    setEtcAtchFileId(etcFileInfo.mbrasAtchFileId);
                    setEtcFileNm(etcFileInfo.fileNm);
                }

                setListLine(atrzLine);

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId, mbrasId]);

    const renderValue = (value: string) => {
        return Util.isEmpty(value) ? "-" : value;
    };

    return (
        <div className="w100p bsBdb p2 pb8">
            {/* 결재라인 */}
            {showAtrzLine && (
                <AtrzLineBox
                    listLine={listLine}
                    open={openLine}
                    onToggle={() => setOpenLine((value) => !value)}
                    showOrgInfo={true}
                />
            )}

            {/* 조합원 정보 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    조합원 정보
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            성명
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(mbrasNm)}
                        </div>
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 bdl1 bdcDDDDDD">
                            휴대전화번호
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.setPhoneNum(telno))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            생년월일
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(brdtDate, "-", "YYYYMMDD"))}
                        </div>
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 bdl1 bdcDDDDDD">
                            성별
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("GNDR_CD", gndrCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            문서구분
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("MBRAS_ATRZ_SE_CD", mbrasAtrzSeCd))}
                        </div>
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 bdl1 bdcDDDDDD">
                            신청일자
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(aplyYmd, "-", "YYYYMMDD"))}
                        </div>
                    </div>
                </div>
            </div>

            {/* 변경 신청 내역 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    변경 신청 내역
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h40 bgcFAFAFA bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC fm-b fs13 fc555555">
                            구분
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            현재
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            변경
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            신청기간
                        </div>
                        <div className="flx1 h42 dpFlx aiC jcC fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(leaveBgngYmd, "-", "YYYYMMDD"))}
                            <span className="ml10 mr10">~</span>
                            {renderValue(Util.cvtDateStrForm(leaveEndYmd, "-", "YYYYMMDD"))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            상태
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(
                                Util.getValToCode("MBRAS_JOIN_STTS_CD", mbrasJoinSttsCd),
                            )}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(
                                Util.getValToCode("MBRAS_JOIN_STTS_CD", chgJoinSttsCd),
                            )}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            휴직분류
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("LEAVE_TYPE_CD", leaveTypeCd) || "기타")}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {leaveTypeCd === "L07" ? renderValue(leaveEtcRsnCn) : "-"}
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            원천징수
                        </div>

                        <div className="flx1 h42 dpFlx aiC jcC bdl1 bdcDDDDDD">
                            <RadioBox
                                codeList={Util.getCodeArray("WTHD_STATUS_CD").map((item: any) => ({ code: item.code, name: item.code === "W01" ? "동의" : "철회" }))}
                                value={wthdAgreCd}
                                btnColor="#555555"
                                btnSize={14}
                                btnClass=""
                                labelClass="ml6 fm-c fs13 fc333333"
                                interval={20}
                                disabled={true}
                            />
                        </div>

                        <div className="flx1 h42 dpFlx aiC jcC bdl1 bdcDDDDDD">
                            <RadioBox
                                codeList={Util.getCodeArray("WTHD_STATUS_CD").map((item: any) => ({ code: item.code, name: item.code === "W01" ? "동의" : "철회" }))}
                                value={chgWthdAgreCd}
                                btnColor="#007BFF"
                                btnSize={14}
                                btnClass=""
                                labelClass="ml6 fm-c fs13 fc333333"
                                interval={20}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 첨부파일 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    첨부파일
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    {Util.isNotEmpty(chgWthdAgreCd) && wthdAgreCd !== chgWthdAgreCd && (
                        <div className="dpFlx h42 bdb1 bdcDDDDDD">
                            <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                원천징수 동의서
                            </div>
                            <div className="flx1 h42 dpFlx aiC pl15 pr15">
                                <MemberFileView
                                    mbrasId={mbrasId}
                                    mbrasAtchFileId={wthdAtchFileId}
                                    mbrFileNm={wthdFileNm}
                                />
                            </div>
                        </div>
                    )}

                    <div className="dpFlx h42">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            기타
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                mbrFileNm={etcFileNm}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MbrasLeaveHistory;